import { FrontendProduct } from "@made-people/nestjs-bff-service";
import { CentraCheckoutApiProduct } from "@made-people/centra-checkout-api";
import { productImageKey } from "../../centra/mappers/utils/get-centra-mapper-options";

export const frontendProductToCheckoutApiProduct = (
  product: FrontendProduct,
): CentraCheckoutApiProduct => {
  const { frontendItems, mediaUrls, mediaObjects } = product;

  return {
    ...product,
    price: undefined,
    ...product.price,
    frontendItems: undefined,
    items: frontendItems.map(
      ({
        item,
        sku,
        quantity,
        sizeId,
        ean,
        itemTableX,
        itemTableY,
        name,
        upc,
        stock,
        warehouses,
      }) => ({
        item: item!,
        sku: sku!,
        quantity,
        sizeId: sizeId!,
        ean: ean!,
        itemTableX: itemTableX!,
        itemTableY: itemTableY!,
        name: name!,
        upc,
        stock,
        // `warehouses` originates from the Shop API product (products-search),
        // NOT the Centra Checkout API. We carry it on the checkout-api shape so
        // it flows through the shared checkout-api -> grease mapper into
        // additionalInventory. Reuse compromise — it conceptually belongs on the
        // FrontendProduct type.
        warehouses,
      }),
    ),
    media: {
      [productImageKey]: mediaUrls,
    },
    mediaObjects: mediaObjects,
  } as unknown as CentraCheckoutApiProduct;
};
